var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavouriteOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42968 8.77261C5.16148 6.85707 11.5462 0.62406 20.4899 0.961953C22.8452 1.0519 29.3912 1.11775 34.3941 7.6301C35.5679 9.15912 39.3548 14.0963 39.0277 20.4798C38.5235 30.2932 28.4926 37.5373 20.155 38.0405C14.2611 38.3954 7.26272 35.5002 3.56631 28.8614C2.75814 27.4029 1.19567 24.4543 1.28226 20.4798C1.40156 14.9422 4.68427 9.7474 9.68146 6.84249",
    stroke: "#030201",
    strokeWidth: 0.646332,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2672_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9536 16.2852C29.7051 14.1694 28.2454 12.0689 25.8694 12.2528C23.6565 12.4292 22.0337 14.2997 20.7991 16.0399C19.8674 13.3568 16.7149 11.3712 13.811 12.2068C9.04348 13.5791 11.3263 20.2333 13.1976 23.0084C15.0688 25.7835 17.5147 27.8534 19.9761 29.9079C20.0688 29.9635 20.1775 29.9876 20.2855 29.9766C20.3934 29.9655 20.4947 29.9198 20.5739 29.8465V29.8465C23.0464 28.0736 25.2731 25.9885 27.1971 23.6447C28.7889 21.6055 30.2797 18.9453 29.9536 16.2852ZM28.9752 18.539C27.9503 23.0084 23.9282 26.4965 20.3643 29.1566C18.0309 27.3137 15.9437 25.1859 14.1526 22.8244C12.5997 20.6396 11.2098 17.4581 12.126 14.752C12.7627 12.8585 14.7039 12.3832 16.4587 12.9505C17.405 13.2163 18.2564 13.7398 18.9156 14.4611C19.5747 15.1823 20.0148 16.0722 20.1857 17.0288C20.2323 17.4121 20.7758 17.3891 20.9622 17.1208C22.1036 15.4266 23.9282 12.6821 26.3275 12.9505C28.9054 13.2188 29.4256 16.5305 28.9752 18.539Z",
    fill: "#030201"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2672_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOff);
export default __webpack_public_path__ + "static/media/favourite-off.17b3b206b3dfac0dce174e2aaed440e6.svg";
export { ForwardRef as ReactComponent };